// extracted by mini-css-extract-plugin
module.exports = {"root":"ScenarioNav_root__odwYj","placeholder":"ScenarioNav_placeholder__2bQUs"};